import { AttendeeLinkType } from '../../../../api/attendees.dao';
import { FormVmItemConfigType } from '../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../infrastructure/utils/form-config.utils';
import { trimSpacesLeft } from '../../../../modules/formatters';
import { plainText } from '../../../../modules/validators';
import { ORDER_BOOKING_BLUEPRINT_PUBLIC_DESCRIPTION_TEXT, ORDER_BOOKING_BLUEPRINT_PUBLIC_NAME_TEXT, ORDER_BOOKING_EVENT_BLUEPRINT_TEXT, PARTICIPANT_LINK_TYPE_TEXT } from './order-booking-event-blueprint.text';

export enum OrderBookingEventBlueprintFieldKey {
    NAME = 'name',
    PUBLIC_NAME = 'publicName',
    PUBLIC_DESCRIPTION = 'publicDescription',
    PARTICIPANT_LINK_TYPE = 'participantLinkType',
    EVENT_ATTRIBUTE_IDS = 'eventAttributeIds',
}

export const FORM_CONFIG = {
    [OrderBookingEventBlueprintFieldKey.NAME]: {
        labelDescriptor: ORDER_BOOKING_EVENT_BLUEPRINT_TEXT,
        defaultValue: '',
    },
    [OrderBookingEventBlueprintFieldKey.PUBLIC_NAME]: {
        labelDescriptor: ORDER_BOOKING_BLUEPRINT_PUBLIC_NAME_TEXT,
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [OrderBookingEventBlueprintFieldKey.PUBLIC_DESCRIPTION]: {
     labelDescriptor: ORDER_BOOKING_BLUEPRINT_PUBLIC_DESCRIPTION_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.long],
        formatters: [trimSpacesLeft]
    },
    [OrderBookingEventBlueprintFieldKey.PARTICIPANT_LINK_TYPE]: {
        labelDescriptor: PARTICIPANT_LINK_TYPE_TEXT,
        defaultValue: AttendeeLinkType.PASSPORT_LINK,
    },
    [OrderBookingEventBlueprintFieldKey.EVENT_ATTRIBUTE_IDS]: {
        labelDescriptor: { id: 'oe.orderBookingEventBlueprintForm.eventAttributes', defaultMessage: 'Event Attributes', description: 'Label text' },
        defaultValue: [],
    },
};

export const orderBookingEventBlueprintFormConfigList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
